import * as React from 'react';
import { convertIcon } from '../components/Icon';
function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23c2 0 9-7.58 9-13s-3.58-9-9-9-9 3.58-9 9 7 13 9 13Zm0-9a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
    fill: "currentColor"
  }));
}
const IconComponent = convertIcon(SvgComponent, 'map_pin');
export default IconComponent;